/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ConversationTimingMetricsOutUnavailable } from './conversationTimingMetricsOutUnavailable';

export interface ConversationTimingMetricsOut {
  expected_duration_s: number | null;
  actual_duration_s: number | null;
  minutes_late: number | null;
  overrun_min: number | null;
  bot_join_offset_s: number | null;
  participants_with_audio: number | null;
  participants_invited_absent: number;
  capture_mode: string;
  platform: string | null;
  silence_total_s: number | null;
  silence_longest_s: number | null;
  gap_count: number;
  gap_total_s: number;
  unavailable: ConversationTimingMetricsOutUnavailable;
}
